import { render, staticRenderFns } from "./LayoutFull.vue?vue&type=template&id=39005750&"
import script from "./LayoutFull.vue?vue&type=script&lang=js&"
export * from "./LayoutFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39005750')) {
      api.createRecord('39005750', component.options)
    } else {
      api.reload('39005750', component.options)
    }
    module.hot.accept("./LayoutFull.vue?vue&type=template&id=39005750&", function () {
      api.rerender('39005750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/LayoutFull.vue"
export default component.exports